import { asWidgetData, asWidgetDataError } from 'adapter/out/client/widgets/data/readWidgetDataApiClient';
import { httpClientFunction } from 'domain/types';
import { right } from 'fp-ts/Either';
import ReadWidgetDataClient from 'use-case/widgets/data/read/readWidgetDataClient';
import ReadWidgetDataCriteria from 'use-case/widgets/data/read/readWidgetDataCriteria';

const getUrl = (baseUrl: string, criteria: ReadWidgetDataCriteria) => {
    if (criteria.destination === 'texts') {
        return `${baseUrl}/dashboards/dashboards/${criteria.proxyContext.dashboardId}/proxy/api-v3/dashboards/${criteria.destination}/${criteria.widgetId}`;
    }
    return `${baseUrl}/dashboards/dashboards/${criteria.proxyContext.dashboardId}/proxy/api-v3/dashboards/${criteria.destination}/${criteria.widgetId}/data`;
};

export default (httpClient: httpClientFunction, baseUrl: string): ReadWidgetDataClient => (criteria: ReadWidgetDataCriteria) => {
    const url = getUrl(baseUrl, criteria);
    return httpClient(
        url,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                language: criteria.proxyContext.language,
                period: criteria.proxyContext.period,
                location_id: criteria.proxyContext.location,
                location_tags: criteria.proxyContext.locationTags ? criteria.proxyContext.locationTags.join(',') : null,
            }),
        }
    )
        .then(async (response) =>
            response.ok
                ? response
                      .json()
                      .then(asWidgetData)
                      .then(right)
                      .catch((error: Error) => asWidgetDataError(error, 500))
                : asWidgetDataError(await response.json(), response.status)
        )
        .catch((error: Error) => asWidgetDataError(error, 500));
};
